<template>
  <table border="1" cellspacing="0">
    <caption>
      承诺内容可自定义模板内容和模板标题
    </caption>
    <tr class="head">
      <td colspan="4" align="center">
        <input class="title" :disabled="disabled" type="text" v-model="valueAtitle" placeholder="请输入文档标题（个人承诺书）">
      </td>
    </tr>
    <tr class="line4">
      <td align="left" colspan="1">
        <div class="p">
          <div>
            本人已接受 ________ 项目三级安全教育培训，同时本人承诺如下：
            <div>
              <textarea
                :disabled="disabled"
                v-model="valueA1"
                placeholder="请输入内容"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="footer">
          <div>项目部告知人:</div>
          <div>承诺人：</div>
          <div>日期：</div>
        </div>
      </td>
    </tr>
  </table>
</template>
  
  <script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueAtitle: '',
      valueA1: ``,
    };
  },
  methods: {
  },
};
</script>
  
  <style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}
table,
table tr th,
table tr td {
  border: 1px solid #000000;
}
table tr td {
  height: 45px;
}
.head {
  background: #ccc;
  color: #000;
  font-weight: bold;
}
.line4 td {
  width: 25%;
}
.p {
  padding: 10px;
  box-sizing: border-box;
}
textarea {
  border: none;
  width: 100%;
  min-height: 500px;
  outline: none;
  line-height: 26px;
}
.footer {
  padding: 20px;
  box-sizing: border-box;
  line-height: 40px;
}
.title{
  outline: none;
  border: none;
  background: none;
  width: 100%;
  text-align: center;
  font-weight: bold;
}
</style>